import React, {useContext, useEffect, useMemo, useState} from 'react';
import {Button, Checkbox, Input} from "@mui/material";
import {KeyboardArrowDown, KeyboardArrowRight, KeyboardArrowUp} from "@mui/icons-material";
import OtherThoughts from "./OtherThoughts";
import {UserContext} from "../context";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {backendURL} from "../assets/constants";
import {Spinner} from "react-bootstrap";

const NegativeThoughtComponent = ({steps, activeStep, handleRight, setSteps}) => {
    const user = useContext(UserContext);
    const isOfflineUser = Boolean(user?.isOfflineUser);
    const navigate = useNavigate();
    const [visible, setVisible] = useState(true);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (user == null) {
            navigate('/');
        }
        return () => {
            // cleanup
        }
    }, [user, navigate]);

    const [rendering, setRendering] = useState(true);
    const [showOtherThoughts, setShowOtherThoughts] = useState(false);

    const toggleShowOtherThoughts = () => {
        setShowOtherThoughts(!showOtherThoughts);
    };

    const toggleVisibility = () => {
        setVisible(!visible);
    }

    useEffect(() => {
        setRendering(true);
        setLoading(true);
        const timer = setTimeout(() => {
            setInputValue(steps[activeStep].answer || '');
            setRendering(false);
            setLoading(false);
        }, 100);
        return () => clearTimeout(timer);
    }, [activeStep, steps]);

    const currentStep = useMemo(() => steps[activeStep], [steps, activeStep]);

    const isLastStep = useMemo(() => activeStep === steps.length - 1, [activeStep, steps]);

    const [inputValue, setInputValue] = useState('');

    const postAnswers = async (steps) => {
        if (!user) {
            alert('User does not exist!');
            return navigate('/error');
        }
        const reqBody = {
            userId: user._id,
            answers: steps.reduce((accumulator, step) => {
                if (step.answer.length === 0) {
                    return accumulator;
                }
                const newObject = {
                    q_id: step.q_id,
                    answer: step.answer,
                };
                return [...accumulator, newObject];
            }, []),
            visible
        };

        if (isOfflineUser) {
            console.info('Offline mode active: skipping answer submission.');
            return null;
        }
        try {
            // await axios.post('https://cognitive-reframing-backend.fly.dev/postAnswer', reqBody);
            return await axios.post(`${backendURL}/postAnswer`, reqBody);
        } catch (error) {
            console.error(error); // Handle errors
            throw error;
        }
    };

    const handleLocalRight = async () => {
        const curStep = {...currentStep};
        curStep.answer = inputValue;
        const newSteps = [...steps];
        newSteps[activeStep] = curStep;
        setSteps(newSteps);
        if (activeStep === steps.length - 1) {
            setLoading(true);
            try {
                await postAnswers(newSteps);
            } catch (e) {
                alert('We could not reach the server. Your answers were kept locally, and you can continue offline.');
            } finally {
                setLoading(false);
                navigate('/end-activity');
            }
        }
        handleRight();
    }

    const onChangeInputValue = (event) => {
        setInputValue(event.target.value);
    }

    return user && (
        !rendering && <>
            {loading && <div className="loading-overlay">
                <Spinner color="#00BFFF" size={100}/>
            </div>
            }
            <div>
                <div className="blue-box-big shadow-sm negativeThoughtDiv">
                    <p className="currentStepQstn">{currentStep.question}</p>
                    <span className="currentStepQstnDesc">{currentStep.description}</span>
                    <Input className="inputAnswerStyle" placeholder="Type your answer here..." value={inputValue}
                           onChange={onChangeInputValue}/>
                    <div className="otherThoughtsDiv">
                        <Button variant="outlined" onClick={toggleShowOtherThoughts} endIcon={showOtherThoughts ? <KeyboardArrowUp/> : <KeyboardArrowDown/>}>
                            Show/Hide Other's Thoughts
                        </Button>
                        <Button variant="contained" onClick={handleLocalRight} endIcon={<KeyboardArrowRight/>}>
                            {isLastStep ? 'Finish' : 'Next'}
                        </Button>
                    </div>
                    {isLastStep &&
                        <div className="hideSubmissionsDiv">
                            <Checkbox checked={!visible} onChange={toggleVisibility}/> <label> Hide my submission from
                            others (all submissions are
                            anonymous)</label>
                        </div>}
                </div>
                <br/>
                <br/>
                {showOtherThoughts && <OtherThoughts steps={steps} activeStep={activeStep}/>}
            </div>
        </>
    )
};

export default NegativeThoughtComponent;
